// import React, { useEffect, useState } from 'react'
// import { Button, Grid, TextField, InputLabel, Select, MenuItem, Input } from '@mui/material'
// import CartItem from './CartItem'
// import { useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux';
// import { createOrder } from '../../state/Order/Action';
// import { getAllProvinces, getDistrict, getWard } from '../../state/Cart/Action';
// import { findProductsByKeyword } from '../../state/Product/Action';
// import Helmet from '../../helmet/Helmet';
// import { IMAGES_URL } from "../../config/apiConfig";


// export default function Cart() {
//     const [_title, _setTitle] = useState('Giỏ hàng')
//     const [_products, _setProducts] = useState([])
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { cart } = useSelector(store => store)

//     const _localHoTen = localStorage.getItem('hoTen') !== null ? JSON.parse(localStorage.getItem('hoTen')) : '';
//     const _localDienThoai = localStorage.getItem('dienThoai') !== null ? JSON.parse(localStorage.getItem('dienThoai')) : '';
//     const _localTinhThanhPho = localStorage.getItem('tinhThanhPho') !== null ? JSON.parse(localStorage.getItem('tinhThanhPho')) : '79Thành phố Hồ Chí Minh';
//     const _localPhuongXa = localStorage.getItem('phuongXa') !== null ? JSON.parse(localStorage.getItem('phuongXa')) : 'Phường Võ Thị Sáu';
//     const _localDiaChi = localStorage.getItem('diaChi') !== null ? JSON.parse(localStorage.getItem('diaChi')) : '';

//     const [_tinhThanhPhofull, setTinhThanhPhofull] = useState([]);
//     const [_quanHuyenfull, setQuanHuyenfull] = useState([]);
//     const [_phuongXafull, setPhuongXafull] = useState([]);

//     const [_hoTen, _setHoTen] = useState('');
//     const [_dienThoai, _setDienThoai] = useState('');
//     const [_tinhThanhPho, _setTinhThanhPho] = useState('');
//     const [_quanHuyen, _setQuanHuyen] = useState('');
//     const [_phuongXa, _setPhuongXa] = useState('');
//     const [_diaChi, _setDiaChi] = useState('');

    
//     const [_error_hoTen, _setError_hoTen] = useState('');
//     const [_error_dienThoai, _setError_dienThoai] = useState('');
//     const [_error_tinhThanhPho, _setError_tinhThanhPho] = useState('');
//     const [_error_quanHuyen, _setError_quanHuyen] = useState('');
//     const [_error_phuongXa, _setError_phuongXa] = useState('');
//     const [_error_diaChi, _setError_diaChi] = useState('');

//     const handleTinhThanhPho = (event) => {
        
//         event.preventDefault();
//         _setTinhThanhPho(event.target.value);
//         if (event.target.value.trim()=='') {
//             _setError_tinhThanhPho(' - Bạn chưa chọn tỉnh thành phố.');
//         } else {
//             _setError_tinhThanhPho('');
//         }
//         dispatch(getWard(event.target.value)).then((res) => (
//             setPhuongXafull(res.ward),
//             _setPhuongXa(_localPhuongXa)
//         ));
//     };

    
//     const handlePhuongXa = (event) => {
//         event.preventDefault();
//         _setPhuongXa(event.target.value);
//         if (event.target.value.trim()=='') {
//             _setError_phuongXa(' - Bạn chưa chọn phường xã.');
//         } else {
//             _setError_phuongXa('');
//         }
//     };

    
//     const VND = new Intl.NumberFormat('vi-VN', {
//         style: 'currency',
//         currency: 'VND',
//     });

//     useEffect(() => {
//         _setHoTen(_localHoTen);
//         _setDienThoai(_localDienThoai);
//         _setDiaChi(_localDiaChi)
//         _setTinhThanhPho(_localTinhThanhPho);
//         dispatch(getAllProvinces()).then((res) => (
//             setTinhThanhPhofull(res.province),
//             _localTinhThanhPho !== '' ? (
//                 dispatch(getDistrict(_localTinhThanhPho)).then((res) => (
                    
//                     setPhuongXafull(res.ward),
//                     _setPhuongXa(_localPhuongXa)
//                 ))
                   

//             ) : ("")
//         )
//         );

//         dispatch(findProductsByKeyword("null")).then((Result) => {
//             _setProducts(Result.products)

//         });


//     }, [])
//     const handleChange_hoTen = (e) => {
//         e.preventDefault();
//         _setHoTen(e.target.value)
//         if (e.target.value.trim()=='') {
//             _setError_hoTen(' - Bạn chưa nhập họ tên.');
//         } else {
//             _setError_hoTen('');
//         }
//     };
//     const handleChange_dienThoai = (e) => {
//         e.preventDefault();
//         const value = e.target.value;
//         const phoneRegex = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;

//         if (phoneRegex.test(value)) {
//             _setDienThoai(value);
//             _setError_dienThoai('');
//         } else {
//             _setDienThoai(value);
//             _setError_dienThoai(' - Vui lòng kiểm tra lại số điện thoại.');
//         }
//     };
//     const handleChange_diaChi = (e) => {
//         e.preventDefault();
//         _setDiaChi(e.target.value)
//         if (e.target.value.trim()=='') {
//             _setError_diaChi(' - Bạn chưa nhập địa chỉ.');
//         } else {
//             _setError_diaChi('');
//         }
//     };

//     const handleCheckout = (event) => {

//         event.preventDefault();

//         if (_dienThoai.length !== 10 || !/^\d{10}$/.test(_dienThoai)) {
//             _setError_dienThoai(' - Số điện thoại phải là 10 chữ số.');
//             return;
//         }
//         localStorage.setItem('hoTen', JSON.stringify(_hoTen))
//         localStorage.setItem('dienThoai', JSON.stringify(_dienThoai))
//         localStorage.setItem('tinhThanhPho', JSON.stringify(_tinhThanhPho))
//         localStorage.setItem('quanHuyen', JSON.stringify(_quanHuyen))
//         localStorage.setItem('phuongXa', JSON.stringify(_phuongXa))
//         localStorage.setItem('diaChi', JSON.stringify(_diaChi))
//         if (_hoTen.trim() == '') {
//             _setError_hoTen(" - Bạn chưa nhập họ tên.")
//         }
//         if (_dienThoai.trim() == '') {
//             _setError_dienThoai(" - Bạn chưa nhập số điện thoại.")
//         }
//         if (_tinhThanhPho.trim() == '') {
//             _setError_tinhThanhPho(" - Bạn chưa chọn tỉnh thành phố.")
//         }
//         if (_quanHuyen.trim() == '') {
//             _setError_quanHuyen(" - Bạn chưa chọn quận huyện.")
//         }
//         if (_phuongXa.trim() == '') {
//             _setError_phuongXa(" - Bạn chưa chọn phường xã.")
//         }
//         if (_diaChi.trim() == '') {
//             _setError_diaChi(" - Bạn chưa nhập địa chỉ.")
//         }
//         if (_hoTen.trim() != ''&&_dienThoai.trim() != ''&&_tinhThanhPho.trim() != ''&&_quanHuyen.trim() != ''&&_phuongXa.trim() != ''&&_diaChi.trim() != '') {
//             const cartData = {
//                 hoTen: _hoTen,
//                 dienThoai: _dienThoai,
//                 diaChi: _diaChi + ", " + _phuongXa + ", " + _quanHuyen?.slice(3) + ", " + _tinhThanhPho.slice(2),
//                 tongSoTien: cart?.totalAmount,
//                 cartItems: cart?.cartItems || ''
//             }
            
//             dispatch(createOrder(cartData));
//             navigate("/xac-nhan-don-hang.html")
//         }

//     }

//     return (
//         <Helmet title={_title}>
//         <div className=' pt-16 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
//             {cart.totalQuantity > 0 ?
//                 <div className='pt-5' >
//                     <div className='lg:grid grid-cols-2 lg:px-16 relative'>
//                         <div className=''>
//                             {cart?.cartItems.map((item) =>
//                                 <div className=' pb-3'>
//                                     <CartItem item={item} />
//                                 </div>
//                             )}
//                         </div>
//                         <form onSubmit={handleCheckout}>
//                             {/* <FormControl sx={{ m: 1, minWidth: 120 }} size="small" > */}
//                             <div className='px-5 sticky top-0 h-[100vh] mt-5 lg:mt-0'>

//                                 <div className='border p-4'>

//                                     <p className='uppercase font-bold opacity-60 pb-4'>Đơn hàng</p>
//                                     <hr />
//                                     <div className='space-y-3 font-semibold mb-10'>
//                                         <div className='flex justify-between pt-3 text-black'>
//                                             <span>Tổng số lượng :</span>
//                                             <span>{cart.totalQuantity}</span>
//                                         </div>
//                                         <div className='flex justify-between pt-3'>
//                                             <span>Tổng số tiền :</span>
//                                             <span>{VND.format(cart.totalAmount * 1000)}</span>
//                                         </div>
//                                         <div className='flex justify-between pt-3 '>
//                                             <span>Phí giao hàng :</span>
//                                             <span>{(cart.totalQuantity > 1 || cart.totalAmount>=700) ?  'Miễn phí':'25,000đ' }</span>
                                            
//                                         </div>
//                                         {!(cart.totalQuantity > 1 || cart.totalAmount>=700) && <div className=' italic text-blue-400 text-xs'>PT2000 miễn phí giao hàng cho hóa đơn từ 700.000đ hoặc từ 2 sản phẩm!</div>}
//                                         <div className='flex justify-between pt-3  font-bold'>
//                                             <span>Tổng thanh toán :</span>
//                                             <span>{(cart.totalQuantity > 1 || cart.totalAmount>=1000) ? VND.format(cart.totalAmount * 1000):VND.format((cart.totalAmount + 25) * 1000) }</span>
//                                         </div>
//                                         <hr />
//                                         <Grid container spacing={1}>
//                                             <Grid item xs={12}>
//                                                 <InputLabel id="HoTen-label" >Họ tên</InputLabel>
//                                                 <TextField required labelId='HoTen-label' id='hoTen' name='hoTen' onChange={handleChange_hoTen} value={_hoTen} defaultValue={_hoTen} fullWidth autoComplete='given-name' />
//                                                 {_error_hoTen && <p className=' italic text-red-400 text-sm'>{_error_hoTen}</p>}
//                                             </Grid>
//                                             <Grid item xs={12}>
//                                                 <InputLabel id="DienThoai-label" >Điện thoại</InputLabel>
//                                                 <TextField onChange={handleChange_dienThoai} required labelId='DienThoai-label' id='dienThoai' name='dienThoai' value={_dienThoai} defaultValue={_dienThoai} fullWidth autoComplete='' />
//                                                 {_error_dienThoai && <p className=' italic text-red-400 text-sm'>{_error_dienThoai}</p>}

//                                             </Grid>
//                                             <Grid item xs={12} >
//                                                 <InputLabel id="TinhThanhPho-label">Tỉnh / Thành phố</InputLabel>
//                                                 <Select
//                                                     labelId="TinhThanhPho-label"
//                                                     id="TinhThanhPho"
//                                                     value={_tinhThanhPho}
//                                                     label="Tỉnh / Thành phố"
//                                                     onChange={handleTinhThanhPho}
//                                                 >
//                                                     {_tinhThanhPhofull?.map((tinhThanhPho) => (
//                                                         <MenuItem value={tinhThanhPho.MaTinh + tinhThanhPho.TenTinh}>{tinhThanhPho.TenTinh}</MenuItem>
//                                                     ))}

//                                                 </Select>
//                                                 {_error_tinhThanhPho && <p className=' italic text-red-400 text-sm'>{_error_tinhThanhPho}</p>}
//                                             </Grid>
                                            
//                                             <Grid item xs={12} >
//                                                 <InputLabel id="PhuongXa-label" >Phường / Xã</InputLabel>
//                                                 <Select

//                                                     labelId="PhuongXa-label"
//                                                     id="PhuongXa"
//                                                     value={_phuongXa}
//                                                     label="Phường / Xã"

//                                                     onChange={handlePhuongXa}
//                                                 >
//                                                     {_phuongXafull?.map((phuongXa) => (
//                                                         <MenuItem value={phuongXa.TenPhuong}>{phuongXa.TenPhuong}</MenuItem>
//                                                     ))}
//                                                 </Select>
//                                                 {_error_phuongXa && <p className=' italic text-red-400 text-sm'>{_error_phuongXa}</p>}
//                                             </Grid>
//                                             <Grid item xs={12} >
//                                                 <InputLabel id="DiaChi-label" >Số nhà, tên đường</InputLabel>
//                                                 <TextField required id='diaChi' onChange={handleChange_diaChi} value={_diaChi} labelId='DiaChi-label' name='diaChi' defaultValue={_diaChi} fullWidth autoComplete='' />
//                                                 {_error_diaChi && <p className=' italic text-red-400 text-sm'>{_error_diaChi}</p>}
//                                             </Grid>

//                                         </Grid>
//                                     </div>
//                                     <hr />
//                                     <Button type='submit' variant="contained" className='w-full mt-5' sx={{ px: '2.5rem', py: '.7rem', bgcolor: '#9155fb' }}>
//                                         Đặt hàng
//                                     </Button>
//                                 </div>
//                             </div>
//                             {/* </FormControl> */}
//                         </form>

//                     </div>
//                 </div>
//                 : <div className=' min-h-[500px]'>

//                     <img src="/gio-hang.jpg" alt='giỏ hàng' />
//                     <div className=' w-full text-end pr-5 pb-5 pt-3'>
//                         <h2 className=" font-bold text-blue-400 text-lg py-3 justify-end">Có thể bạn quan tâm</h2>
//                     </div>


//                     <div className="grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-5 xl:gap-x-8">
//                         {_products?.map((product) => (
//                             <a key={product.MaSanPham} href={`/san-pham/` + product.MaSanPham + `.html`} className="group">
//                                 <div className="k_img overflow-hidden rounded-lg bg-gray-200 ">
//                                     <img
//                                         src={IMAGES_URL + product.MaSanPham?.trim() + "-00.jpg"}
//                                         alt={product.TenSanPham + ' ' + product.MaSanPham}
//                                         className="h-full w-full object-cover object-center group-hover:opacity-75"

//                                         onError={i => i.target.style.display = 'none'}
//                                     />
//                                 </div>
//                                 <h3 className="mt-4 text-sm text-gray-700">{product.TenSanPham} {'(' + product.MaSanPham + ')'}</h3>
                                
//                                 <p className="mt-1 text-md font-medium text-gray-900">{VND.format(product.DonGia)}</p>
//                             </a>
//                         ))}
//                     </div>
//                 </div>}
//         </div >
//         </Helmet>
//     )
// }

import React, { useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Card,
  List,
  Typography,
  Form,
  Input,
  Select,
  Button,
  Divider,
  Alert,
  Empty,
  message,
  Space,
} from "antd";
import {
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ShoppingCartOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import CartItem from "./CartItem";
import Helmet from "../../helmet/Helmet";
import { createOrder } from "../../state/Order/Action";
import { getAllProvinces, getWard } from "../../state/Cart/Action";
import { findProductsByKeyword } from "../../state/Product/Action";
import { IMAGES_URL } from "../../config/apiConfig";

const { Title, Text } = Typography;
const { Option } = Select;

const STORAGE_KEYS = {
  hoTen: "hoTen",
  dienThoai: "dienThoai",
  tinhThanhPho: "tinhThanhPho",
  phuongXa: "phuongXa",
  diaChi: "diaChi",
};

const safeGetLocal = (key, fallback = "") => {
  try {
    const raw = localStorage.getItem(key);
    return raw !== null ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

const saveLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value ?? ""));
};

const phoneValidator = (_, value) => {
  if (!value || !value.trim()) {
    return Promise.reject(new Error("Bạn chưa nhập số điện thoại."));
  }

  const normalized = value.replace(/\s+/g, "");
  if (!/^0\d{9}$/.test(normalized)) {
    return Promise.reject(
      new Error("Số điện thoại phải gồm 10 chữ số và bắt đầu bằng số 0.")
    );
  }

  return Promise.resolve();
};

const getProvinceValue = (item) =>
  `${item?.MaTinh || ""}${item?.TenTinh || ""}`;

const getProvinceLabel = (item) =>
  item?.TenTinh || item?.name || item?.ten || "";

const getWardValue = (item) =>
  item?.TenPhuong ||
  item?.TenXa ||
  item?.name ||
  item?.ten ||
  item?.WardName ||
  item?.Name ||
  "";

const getWardKey = (item, index) =>
  item?.MaPhuong ||
  item?.MaXa ||
  item?.WardCode ||
  item?.id ||
  getWardValue(item) ||
  index;

export default function Cart() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cart } = useSelector((store) => store);

  const [form] = Form.useForm();

  const [title] = useState("Giỏ hàng");
  const [products, setProducts] = useState([]);
  const [provinceOptions, setProvinceOptions] = useState([]);
  const [wardOptions, setWardOptions] = useState([]);
  const [loadingProvince, setLoadingProvince] = useState(false);
  const [loadingWard, setLoadingWard] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const localHoTen = safeGetLocal(STORAGE_KEYS.hoTen, "");
  const localDienThoai = safeGetLocal(STORAGE_KEYS.dienThoai, "");
  const localTinhThanhPho = safeGetLocal(
    STORAGE_KEYS.tinhThanhPho,
    "79Thành phố Hồ Chí Minh"
  );
  const localPhuongXa = safeGetLocal(STORAGE_KEYS.phuongXa, "");
  const localDiaChi = safeGetLocal(STORAGE_KEYS.diaChi, "");

  const currency = useMemo(
    () =>
      new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }),
    []
  );

  const freeShip =
    (cart?.totalQuantity || 0) > 1 || (cart?.totalAmount || 0) >= 700;
  const shippingFee = freeShip ? 0 : 25000;
  const subtotal = (cart?.totalAmount || 0) * 1000;
  const totalPayment = subtotal + shippingFee;

  useEffect(() => {
    form.setFieldsValue({
      hoTen: localHoTen,
      dienThoai: localDienThoai,
      tinhThanhPho: localTinhThanhPho,
      phuongXa: localPhuongXa,
      diaChi: localDiaChi,
    });

    const init = async () => {
      try {
        setLoadingProvince(true);
        const provinceRes = await dispatch(getAllProvinces());
        setProvinceOptions(provinceRes?.province || []);
      } catch (error) {
        message.error("Không tải được danh sách tỉnh/thành phố.");
      } finally {
        setLoadingProvince(false);
      }

      if (localTinhThanhPho) {
        try {
          setLoadingWard(true);

          // Đi trực tiếp từ tỉnh/thành phố -> phường/xã
          const wardRes = await dispatch(getWard(localTinhThanhPho));

          setWardOptions(
            wardRes?.ward ||
              wardRes?.data ||
              wardRes?.phuongXa ||
              wardRes?.items ||
              []
          );
        } catch (error) {
          message.error("Không tải được danh sách phường/xã.");
        } finally {
          setLoadingWard(false);
        }
      }
    };

    init();

    dispatch(findProductsByKeyword("null")).then((result) => {
      setProducts(result?.products || []);
    });
  }, [
    dispatch,
    form,
    localHoTen,
    localDienThoai,
    localTinhThanhPho,
    localPhuongXa,
    localDiaChi,
  ]);

  const handleProvinceChange = async (value) => {
    form.setFieldsValue({
      tinhThanhPho: value,
      phuongXa: undefined,
    });

    setWardOptions([]);

    if (!value) return;

    try {
      setLoadingWard(true);

      // Đi trực tiếp từ tỉnh/thành phố -> phường/xã
      const res = await dispatch(getWard(value));

      setWardOptions(
        res?.ward || res?.data || res?.phuongXa || res?.items || []
      );
    } catch {
      message.error("Không tải được phường/xã.");
    } finally {
      setLoadingWard(false);
    }
  };

  const onFinish = async (values) => {
    try {
      setSubmitting(true);

      saveLocal(STORAGE_KEYS.hoTen, values.hoTen);
      saveLocal(STORAGE_KEYS.dienThoai, values.dienThoai);
      saveLocal(STORAGE_KEYS.tinhThanhPho, values.tinhThanhPho);
      saveLocal(STORAGE_KEYS.phuongXa, values.phuongXa);
      saveLocal(STORAGE_KEYS.diaChi, values.diaChi);

      const diaChiGiaoHang = [
        values?.diaChi?.trim(),
        values?.phuongXa,
        values?.tinhThanhPho,
      ]
        .filter(Boolean)
        .join(", ");

      const cartData = {
        hoTen: values.hoTen?.trim(),
        dienThoai: values.dienThoai?.trim(),
        diaChi: diaChiGiaoHang,
        tongSoTien: cart?.totalAmount || 0,
        cartItems: cart?.cartItems || [],
      };

      await dispatch(createOrder(cartData));
      message.success("Đặt hàng thành công.");
      navigate("/xac-nhan-don-hang.html");
    } catch (error) {
      message.error("Đặt hàng thất bại, vui lòng thử lại.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Helmet title={title}>
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-16 sm:px-6 lg:px-8">
        {(cart?.totalQuantity || 0) > 0 ? (
          <Row gutter={[24, 24]} className="pt-5">
            <Col xs={24} lg={14}>
              <Card
                bordered={false}
                className="rounded-2xl shadow-sm"
                bodyStyle={{ padding: 20 }}
              >
                <Space align="center" size={10} className="mb-4">
                  <ShoppingCartOutlined style={{ fontSize: 20 }} />
                  <Title level={4} style={{ margin: 0 }}>
                    Sản phẩm trong giỏ
                  </Title>
                </Space>

                <List
                  itemLayout="vertical"
                  dataSource={cart?.cartItems || []}
                  locale={{ emptyText: "Chưa có sản phẩm trong giỏ." }}
                  renderItem={(item, index) => (
                    <List.Item key={item?.id || item?.MaSanPham || index}>
                      <CartItem item={item} />
                    </List.Item>
                  )}
                />
              </Card>
            </Col>

            <Col xs={24} lg={10}>
              <div className="lg:sticky lg:top-20">
                <Card
                  title="Thông tin đặt hàng"
                  bordered={false}
                  className="rounded-2xl shadow-sm"
                >
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <Text>Tổng số lượng</Text>
                      <Text strong>{cart?.totalQuantity || 0}</Text>
                    </div>

                    <div className="flex justify-between">
                      <Text>Tạm tính</Text>
                      <Text strong>{currency.format(subtotal)}</Text>
                    </div>

                    <div className="flex justify-between">
                      <Text>Phí giao hàng</Text>
                      <Text strong>
                        {shippingFee === 0
                          ? "Miễn phí"
                          : currency.format(shippingFee)}
                      </Text>
                    </div>

                    {!freeShip && (
                      <Alert
                        showIcon
                        type="info"
                        message="Miễn phí giao hàng cho đơn từ 700.000đ hoặc từ 2 sản phẩm."
                      />
                    )}

                    <Divider style={{ margin: "16px 0" }} />

                    <div className="flex justify-between">
                      <Text strong style={{ fontSize: 16 }}>
                        Tổng thanh toán
                      </Text>
                      <Text strong style={{ fontSize: 18, color: "#cf1322" }}>
                        {currency.format(totalPayment)}
                      </Text>
                    </div>
                  </div>

                  <Divider />

                  <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    requiredMark={false}
                    size="large"
                  >
                    <Form.Item
                      label="Họ tên"
                      name="hoTen"
                      rules={[
                        { required: true, message: "Bạn chưa nhập họ tên." },
                      ]}
                    >
                      <Input
                        prefix={<UserOutlined />}
                        placeholder="Nhập họ tên người nhận"
                        autoComplete="name"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Điện thoại"
                      name="dienThoai"
                      rules={[{ validator: phoneValidator }]}
                    >
                      <Input
                        prefix={<PhoneOutlined />}
                        placeholder="Nhập số điện thoại"
                        maxLength={10}
                        autoComplete="tel"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Tỉnh / Thành phố"
                      name="tinhThanhPho"
                      rules={[
                        {
                          required: true,
                          message: "Bạn chưa chọn tỉnh/thành phố.",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Chọn tỉnh / thành phố"
                        loading={loadingProvince}
                        onChange={handleProvinceChange}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {provinceOptions.map((item, index) => (
                          <Option
                            key={item?.MaTinh || item?.TenTinh || index}
                            value={getProvinceValue(item)}
                          >
                            {getProvinceLabel(item)}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Phường / Xã"
                      name="phuongXa"
                      rules={[
                        { required: true, message: "Bạn chưa chọn phường/xã." },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Chọn phường / xã"
                        loading={loadingWard}
                        disabled={!form.getFieldValue("tinhThanhPho")}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? "")
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {wardOptions.map((item, index) => {
                          const value = getWardValue(item);

                          return (
                            <Option key={getWardKey(item, index)} value={value}>
                              {value}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      label="Số nhà, tên đường"
                      name="diaChi"
                      rules={[
                        { required: true, message: "Bạn chưa nhập địa chỉ." },
                      ]}
                    >
                      <Input
                        prefix={<EnvironmentOutlined />}
                        placeholder="Ví dụ: 12 Nguyễn Trãi"
                      />
                    </Form.Item>

                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      size="large"
                      loading={submitting}
                    >
                      Đặt hàng
                    </Button>
                  </Form>
                </Card>
              </div>
            </Col>
          </Row>
        ) : (
          <div className="min-h-[500px] pt-8">
            <Card
              bordered={false}
              className="mb-6 rounded-2xl shadow-sm"
              bodyStyle={{ padding: 32 }}
            >
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Giỏ hàng của bạn đang trống"
              />
            </Card>

            <div className="mb-4 flex items-center gap-2">
              <GiftOutlined />
              <Title level={4} style={{ margin: 0 }}>
                Có thể bạn quan tâm
              </Title>
            </div>

            <Row gutter={[16, 16]}>
              {products?.map((product, index) => (
                <Col
                  xs={12}
                  sm={12}
                  md={8}
                  xl={6}
                  xxl={4}
                  key={product?.MaSanPham || index}
                >
                  <Link to={`/san-pham/${product?.MaSanPham}.html`}>
                    <Card
                      hoverable
                      className="h-full overflow-hidden rounded-2xl"
                      cover={
                        <div className="aspect-[3/4] overflow-hidden bg-gray-100">
                          <img
                            src={`${IMAGES_URL}${product?.MaSanPham?.trim()}-00.jpg`}
                            alt={`${product?.TenSanPham || ""} ${
                              product?.MaSanPham || ""
                            }`}
                            className="h-full w-full object-cover"
                            onError={(e) => {
                              e.currentTarget.style.display = "none";
                            }}
                          />
                        </div>
                      }
                    >
                      <div className="min-h-[48px]">
                        <Text strong>
                          {product?.TenSanPham} ({product?.MaSanPham})
                        </Text>
                      </div>
                      <div className="mt-2">
                        <Text
                          style={{
                            fontSize: 16,
                            color: "#cf1322",
                            fontWeight: 700,
                          }}
                        >
                          {currency.format(product?.DonGia || 0)}
                        </Text>
                      </div>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    </Helmet>
  );
}